import { Ability } from '@casl/ability';
import store from '@/store';
import { initialAbility } from './config';

const userData = store.state.user;

const existingAbility = userData ? userData.abilities : null;

export default new Ability(existingAbility || initialAbility);
